<template>
  <el-select
    :value="value"
    @change="change($event)"
    :placeholder="item.placeholder"
    :popper-append-to-body="!item.popperAppendToBody"
    :no-data-text="nodatatext"
    :multiple="item.multiple"
    :disabled="item.disabled"
    :style="item.multiple ? 'width:100%' : false"
    :filterable="!item.filterable"
    v-bind="item"
    clearable
    class="sr-select"
  >
    <el-option
      v-for="(op, index) in list"
      :key="index"
      :label="item.label ? op[item.label] : op.dataName"
      :value="item.value ? op[item.value] : op.dataValue"
    ></el-option>
  </el-select>
</template>

<!--
  功能：下拉框组件
  汪振涛
  时间：2020年11月19日 17:09:02
  版本：v1.0
-->
<script>
export default {
  name: "SrSelect",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String | Number | Array,
    item: {
      type: Object,
      default: {},
    },
    nodatatext: {
      type: String,
      default() {
        return "无数据";
      },
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    config: {
      type: Object,
      default() {
        return {
          label: "label",
          value: "value",
        };
      },
    },
  },
  methods: {
    change(value) {
      this.$emit("change", value);
    },
  },
};
</script>




// WEBPACK FOOTER //
// packages/SrSelect/SrSelect.vue